/* eslint-disable max-len */
import React from 'react';

const ZendeskIcon: React.FC = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="16" cy="16" r="16" fill="#F3F3F5"/>
			<g clipPath="url(#clip0_22479_28904)">
				<path d="M8.00879 22.0987L15.3849 13.1934V22.0987H8.00879Z" fill="#03343B"/>
				<path d="M16.6133 18.9029V10.002H23.988L16.6133 18.9029Z" fill="#03343B"/>
				<path d="M24.0003 22.1013H16.6036C16.5999 21.5287 16.7316 20.9632 16.9879 20.4511C17.2442 19.939 17.6179 19.4947 18.0785 19.1544C18.6586 18.7116 19.358 18.4528 20.0866 18.4112C20.8152 18.3696 21.5395 18.5473 22.1661 18.9213C23.3537 19.6441 23.9402 20.7129 24.0003 22.1013Z" fill="#03343B"/>
				<path d="M8 10H15.3996C15.3527 11.3195 14.822 12.381 13.7106 13.0789C12.3764 13.9249 10.9924 13.9175 9.66407 13.0628C8.56886 12.3634 8.04838 11.3078 8 10Z" fill="#03343B"/>
			</g>
			<defs>
				<clipPath id="clip0_22479_28904">
					<rect width="16" height="16" fill="white" transform="translate(8 8)"/>
				</clipPath>
			</defs>
		</svg>

	);
};

export default ZendeskIcon;